import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { BRAND_CLASSIFICATION } from 'domains/seller-product/constants'

const propTypes = {
  classification: PropTypes.shape({
    name: PropTypes.string
  })
}

/**
 * @param {object} classification
 */
const ProductBrandClassificationBadge = ({ classification }) => {
  const colorMap = {
    [BRAND_CLASSIFICATION.HIGH_END_LUXURY]     : 'success',
    [BRAND_CLASSIFICATION.LUXURY]              : 'success',
    [BRAND_CLASSIFICATION.ASPIRATIONAL_LUXURY] : 'info',
    [BRAND_CLASSIFICATION.BRANDED]             : 'primary'
  }

  const selectedColor = colorMap[ classification?.name ] || 'default'

  return (
    <StatusBadge
      color={ selectedColor }
      label={ classification?.name }
    />
  )
}

ProductBrandClassificationBadge.propTypes = propTypes

export default ProductBrandClassificationBadge
